module.exports = __webpack_public_path__ + "img/play-smoke.5ce7ead0.svg";